/**
 * Все оверлеи попадают в конец body в момент открытия: q-dialog — через портал
 * Quasar (createGlobalNode → body.appendChild), дропдауны и селекты — через
 * <Teleport to="body">. Значит последний совпавший в порядке DOM и есть верхний.
 *
 * Hover-дропдауны исключены намеренно: они открываются от наведения мыши и
 * ничего не ждут от клавиатуры, но, всплыв поверх открытого подтверждения,
 * иначе перехватывали бы у него звание верхнего оверлея и глушили ESC/Enter.
 */
const OVERLAY_SELECTOR =
    ".q-dialog, .dropdown-content:not(.dropdown-content--hover), .app-select__dropdown";

/**
 * Лежит ли элемент в самом верхнем открытом оверлее. Так вложенные модалки,
 * дропдауны и селекты разбираются, чей сейчас Escape.
 */
export function isTopmostOverlay(el: HTMLElement | null): boolean {
    if (!el) {
        return false;
    }
    const overlays = document.querySelectorAll(OVERLAY_SELECTOR);
    const top = overlays[overlays.length - 1];
    return !!top && top.contains(el);
}
